import $ from "jquery";
import Swiper from "swiper/bundle";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

function TopEventSlider() {
  var swiper = new Swiper(".js-top-event-slider", {
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
    },
    lazy: true,
    loop: true,
    spaceBetween: 10,
    speed: 300,
    slidesPerView: "auto",
    centeredSlides: true,
    breakpoints: {
      768: {
        spaceBetween: 20,
      },
    },
    pagination: {
      el: ".js-top-event-slider-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".js-top-event-slider-next",
      prevEl: ".js-top-event-slider-prev",
    },
    // キーボード操作
    keyboard: {
      enabled: true,
    },
  });

  //再生/停止ボタン
  $(".js-top-event-slider-stop-button").on("click", function () {
    if ($(this).hasClass("is-pause")) {
      swiper.autoplay.start();
      $(this).removeClass("is-pause");
      $(this).text("停止する");
    } else {
      swiper.autoplay.stop();
      $(this).addClass("is-pause");
      $(this).text("再生する");
    }
  });
}

export { TopEventSlider };
